export const pageLayoutRootDataAttr = 'data-core-page-layout-root'
export const pageLayoutRootDataAttrName = 'pageCoreLayoutRoot'
